'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _CheckIcon = require('../../icons/CheckIcon');

var _CheckIcon2 = _interopRequireDefault(_CheckIcon);

var _MoreIcon = require('../../icons/MoreIcon');

var _MoreIcon2 = _interopRequireDefault(_MoreIcon);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckBox = function CheckBox(_ref) {
  var children = _ref.children,
      checked = _ref.checked,
      disabled = _ref.disabled,
      env = _ref.env,
      name = _ref.name,
      onChange = _ref.onChange,
      indeterminate = _ref.indeterminate;

  var icon = indeterminate && _react2.default.createElement(_MoreIcon2.default, { size: 'small' }) || checked && _react2.default.createElement(_CheckIcon2.default, { size: 'small' });

  var cn = _bind2.default.bind(_styles2.default);
  var checkboxClasses = cn('checkbox', {
    'checkbox--light': env === 'light',
    'checkbox--dark': env === 'dark',
    'checkbox--disabled': disabled
  });

  return _react2.default.createElement(
    'div',
    { className: checkboxClasses },
    _react2.default.createElement('input', {
      className: _styles2.default.checkbox__input,
      type: 'checkbox',
      checked: checked,
      disabled: disabled,
      onChange: onChange,
      id: name
    }),
    _react2.default.createElement(
      'label',
      { htmlFor: name, className: _styles2.default.checkbox__label },
      _react2.default.createElement(
        'span',
        { className: _styles2.default.checkbox__box },
        icon
      ),
      _react2.default.createElement(
        'span',
        { className: _styles2.default.checkbox__text },
        children
      )
    )
  );
};

CheckBox.propTypes = {
  children: _react.PropTypes.node,
  checked: _react.PropTypes.bool,
  indeterminate: _react.PropTypes.bool,
  disabled: _react.PropTypes.bool,
  env: _react.PropTypes.oneOf(['light', 'dark']),
  name: _react.PropTypes.string.isRequired,
  onChange: _react.PropTypes.func
};

CheckBox.defaultProps = {
  checked: false,
  disabled: false,
  indeterminate: false,
  env: 'light',
  onChange: function onChange() {}
};

exports.default = CheckBox;